import React, { useState } from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import { gallery, videos } from '../data/content';
import { PageIntro } from '../components/ui/PageIntro';
import { PhotoLightbox } from '../components/media/PhotoLightbox';
export function Media() {
  usePageTitle('Beeld & geluid');
  const [active, setActive] = useState<number | null>(null);
  const [featured, ...rest] = videos;
  return <>
      <PageIntro eyebrow="Beeldmateriaal" title={<>
            Beeld &amp; <em className="text-amber" data-id="element-373" data-mp="1sbucls84wsf1">geluid</em>.
          </>} intro="Een indruk van mijn optredens: van het afstudeerconcert aan het conservatorium tot Theater Blaricum. Zet het geluid aan." data-id="element-372" data-mp="1wdfiuuq5y8g9" />

      <section aria-labelledby="videos-title" className="w-full bg-ink" data-id="element-374" data-mp="219w6zoxd4mtc">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-10 lg:py-24" data-id="element-375" data-mp="3hoxrbuz46baz">
          <h2 id="videos-title" className="sr-only" data-id="element-376" data-mp="3cqwa7fl90m25">Video’s</h2>
          <figure className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-end" data-id="element-377" data-mp="3cqe65wsch3jo">
            <video src={`${featured.src}#t=0.5`} controls preload="metadata" playsInline className="aspect-video w-full rounded-sm bg-stage lg:col-span-9" data-id="element-378" data-mp="1onapbavbyciq" />
            <figcaption className="lg:col-span-3" data-id="element-379" data-mp="23l339yl8asut">
              <p className="text-sm text-amber" data-id="element-380" data-mp="23js1237flt5t">{featured.artist}</p>
              <p className="mt-2 font-serif text-4xl leading-tight text-paper" data-id="element-381" data-mp="15xun8j3zyc07">{featured.title}</p>
              <p className="mt-3 text-[15px] leading-relaxed text-sand" data-id="element-382" data-mp="1avw4qzlry39k">{featured.context}</p>
            </figcaption>
          </figure>

          <ul className="mt-16 grid grid-cols-1 gap-x-6 gap-y-12 md:grid-cols-2" data-id="element-383" data-mp="1ftxolmr0y6m3">
            {rest.map(v => <li key={v.src} data-id="element-384" data-mp="1knju8uyrta8e">
                <figure data-id="element-385" data-mp="n735ou9uvfaq">
                  <video src={`${v.src}#t=0.5`} controls preload="metadata" playsInline className="aspect-video w-full rounded-sm bg-stage" data-id="element-386" data-mp="n7mm26juxvmn" />
                  <figcaption className="mt-4 flex items-baseline justify-between gap-4 border-b border-line pb-4" data-id="element-387" data-mp="s3tkle9xc4uk">
                    <span className="font-serif text-2xl text-paper" data-id="element-388" data-mp="k2vs7q4fgvtt">
                      {v.title} <span className="text-muted" data-id="element-389" data-mp="f42mijvdu947">— {v.artist}</span>
                    </span>
                    <span className="shrink-0 text-right text-sm text-muted" data-id="element-390" data-mp="tu9xyfmz2rve">{v.context}</span>
                  </figcaption>
                </figure>
              </li>)}
          </ul>
        </div>
      </section>

      <section aria-labelledby="photos-title" className="w-full border-t border-line bg-stage" data-id="element-391" data-mp="3scowgqfqf6i1">
        <div className="mx-auto max-w-7xl px-5 py-20 md:px-10 lg:py-24" data-id="element-392" data-mp="b4k17mznfw0u">
          <h2 id="photos-title" className="font-serif text-5xl leading-[1.02] tracking-tight text-paper" data-id="element-393" data-mp="b5v5rp0x57t0">
            Foto’s
          </h2>
          <ul className="mt-12 columns-1 gap-3 sm:columns-2 lg:columns-3" data-id="element-394" data-mp="1mjgtd5r4r1cf">
            {gallery.map((p, i) => <li key={p.src} className="mb-3 break-inside-avoid" data-id="element-395" data-mp="1hlfaaktpf20y" data-mpi={i}>
                <button type="button" onClick={() => setActive(i)} aria-label={`Vergroot foto: ${p.alt}`} className="group block w-full overflow-hidden rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-amber" data-id="element-396" data-mp="1p44zsrt0229c">
                  <img src={p.src} alt={p.alt} loading="lazy" className="w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-397" data-mp="1k4im6h99ek00" />
                </button>
              </li>)}
          </ul>
        </div>
      </section>

      <PhotoLightbox photos={gallery} index={active} onChange={setActive} data-id="element-398" data-mp="1z08cgrlh9jaj" />
    </>;
}